import { render } from "./MainMenuItem.vue?vue&type=template&id=5b6c8265&scoped=true&ts=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=ts"
export * from "./MainMenuItem.vue?vue&type=script&lang=ts"

import "./MainMenuItem.vue?vue&type=style&index=0&id=5b6c8265&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6c8265"]])

export default __exports__